module.exports = __webpack_public_path__ + "static/media/bilateral_standing_activity_tolerance.55d811da.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/bilateral_standing_activity_tolerance.png
// module id = 705
// module chunks = 0